<template>
    <div class="award" :class="$mq">
        <div class="icon" :style="{ 'background-image': `url(${icon})` }" />
        <div class="text">
            <base-text type="h4">{{ name }}</base-text>
            <base-text type="p">{{ description }}</base-text>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'award',

        props: {
            name: {
                type: String,
                required: true,
            },

            description: {
                type: String,
                required: true,
            },

            icon: {
                type: Array,
                required: true,
            },
        },
    };
</script>

<style lang="scss" scoped>
    .award {
        display: flex;
        align-items: center;

        &:not(:last-of-type) {
            margin-bottom: $standard-space-mobile;
        }

        .text {
            width: 75%;

            .h4 {
                margin-bottom: 10px;
            }
        }

        .icon {
            width: 25%;
            height: 250px;
            background-size: contain;
            background-repeat: no-repeat;
            background-position: center;
            margin-right: 30px;
        }

        &.tablet,
        &.mobile {
            flex-direction: column;

            .icon {
                margin-right: 0;
            }

            .text {
                width: 100%;
            }
        }

        &.mobile {
            .icon {
                width: 70%;
            }
        }
    }
</style>
